import { WebBuilderAssets } from '__generated__/types';
import { Uploader } from '__generated__/Uploader';
import {
    WebBuilderBriefFields_inspirationFiles,
    WebBuilderBriefFields_referenceFiles,
} from '__generated__/WebBuilderBriefFields';
import CheckboxList from 'common/components/CheckboxList';
import Text from 'common/components/Text';
import DescriptionField from 'projects/components/BriefFields/DescriptionField';
import InspirationFilesField from 'projects/components/BriefFields/InspirationFilesField';
import InspirationUrlsField from 'projects/components/BriefFields/InspirationUrlsField';
import ReferenceFilesField from 'projects/components/BriefFields/ReferenceFilesField';
import TitleField from 'projects/components/BriefFields/TitleField';
import ContentSetting from 'projects/components/ContentSetting';
import { ObservableField as Field, ObservableForm } from 'projects/components/ObservableForm';
import { trackViewedBriefEvent } from 'projects/events';
import React, { useEffect } from 'react';

export interface Props<T> {
    form: ObservableForm<T>;
    brief: {
        id: string;
        uploader: Uploader;
    };
}

interface Fields {
    title: string;
    description: string;
    referenceFiles: WebBuilderBriefFields_referenceFiles[];
    inspirationFiles: WebBuilderBriefFields_inspirationFiles[];
    inspirationUrls: string[];
    url: string;
    assets: WebBuilderAssets[];
}

const DetailsPage: <T extends Fields>(props: Props<T>) => React.ReactElement<Props<T>> = ({
    form,
    brief,
}) => {
    useEffect(() => {
        trackViewedBriefEvent({
            id: brief.id,
            page: 'Details',
        });
    }, []);

    return (
        <ContentSetting>
            <TitleField form={form} />

            <DescriptionField form={form} />
            <ReferenceFilesField form={form} uploader={brief.uploader} />
            <InspirationFilesField form={form} uploader={brief.uploader} />
            <InspirationUrlsField form={form} />

            <Field
                form={form}
                name="url"
                title={__('Link to your existing website, if you have one')}
                render={() => <Text fill={true} {...form.attach('url')} />}
            />

            <Field
                form={form}
                name="assets"
                title={__('Do you have any of the following?')}
                render={() => (
                    <CheckboxList
                        options={[
                            {
                                value: WebBuilderAssets.LOGO,
                                label: __('Logo & Branding'),
                            },
                            {
                                value: WebBuilderAssets.IMAGES_VIDEO,
                                label: __('Images & Visual Assets'),
                            },
                            {
                                value: WebBuilderAssets.COPY,
                                label: __('Website & Product Copy'),
                            },
                        ]}
                        {...form.attach('assets')}
                    />
                )}
            />
        </ContentSetting>
    );
};

export default DetailsPage;
